import React from 'react';

const GenderInput = ({ value, onChange, t }) => (
  <fieldset className="bz-fieldset">
    <legend className="bz-fieldset__legend">{t('gender')}</legend>
    <div className="fc-segmented" role="tablist" aria-label={t('gender')}>
      <button
        type="button"
        role="tab"
        aria-selected={value === true}
        className="fc-segmented__item"
        onClick={() => onChange(true)}
      >
        {t('male')}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === false}
        className="fc-segmented__item"
        onClick={() => onChange(false)}
      >
        {t('female')}
      </button>
    </div>
  </fieldset>
);

export default GenderInput;
